import { useState } from 'react';
import ScreenHeader from '../../components/ScreenHeader';
import FormBuscarActasPorArticulo from './FormBuscarActasPorArticulo';
import { Button } from 'react-bootstrap';
import GraficoActasPorArticulo from './GraficoActasPorArticulo';

const ActasPorArticulo = () => {
  const [data, setData] = useState(null);
  const [fechasBusqueda, setFechasBusqueda] = useState(null);

  return (
    <div>
      <ScreenHeader screenHeaderTitle="Actas por Artículo" />
      {data && data.length > 0 ? (
        <div className="d-flex flex-column gap-2">
          <GraficoActasPorArticulo
            data={data}
            fechasBusqueda={fechasBusqueda}
            setData={setData}
            setFechasBusqueda={setFechasBusqueda}
          />
        </div>
      ) : (
        <FormBuscarActasPorArticulo setData={setData} setFechasBusqueda={setFechasBusqueda} />
      )}
    </div>
  );
};

export default ActasPorArticulo;
